var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-changer" }, [
    _vm.data.prev && _vm.data.prev.url
      ? _c(
          "a",
          {
            class: [
              "page-changer__link page-changer__link--prev",
              { "is-disabled": !_vm.data.prev },
            ],
            attrs: {
              href: _vm.data.prev ? _vm.data.prev.url : "javascript:void(0)",
            },
          },
          [
            _c("z-icon", {
              staticClass: "page-changer__link-icon",
              attrs: {
                name: "arrow_long",
                dir: "left",
                width: "40",
                height: "40",
                color: "#0B2C62",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "page-changer__link-text" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    (_vm.data.prev && _vm.data.prev.name) || _vm.text.prev
                  ) +
                  "\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-changer__button-wrapper" },
      [
        _vm.data["back-link"]
          ? _c(
              "z-button",
              {
                staticClass: "page-changer__button u-bold",
                attrs: {
                  tag: "a",
                  size: "m",
                  kind: "secondary",
                  href: _vm.data["back-link"],
                },
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.text.backLink) + "\n        "
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.data.next && _vm.data.next.url
      ? _c(
          "a",
          {
            class: [
              "page-changer__link page-changer__link--next",
              { "is-disabled": !_vm.data.next },
            ],
            attrs: {
              href: _vm.data.next ? _vm.data.next.url : "javascript:void(0)",
            },
          },
          [
            _c("span", { staticClass: "page-changer__link-text" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    (_vm.data.next && _vm.data.next.name) || _vm.text.next
                  ) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("z-icon", {
              staticClass: "page-changer__link-icon",
              attrs: {
                name: "arrow_long",
                dir: "right",
                width: "40",
                height: "40",
                color: "#0B2C62",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }